import axiosApiClient from "../axios";

const PATH = '/api/branch';

export const getAllBranches = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all branches');
    }
};

export const getAllBranchByUserName = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/${username}/username`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get branch by username');
    }
};

export const getAllBranchById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get branch by ID');
    }
};

export const getBranchDetailById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}/detail`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get branch detail by ID');
    }
};

export const addBranch = async (branch) => {
    try {
        console.log('Making API call to add branch:', branch);
        const response = await axiosApiClient.post(PATH, branch);
        console.log('Branch creation successful:', response.data);
        return response;
    } catch (err) {
        console.error('Branch creation API error:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);

        if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
            throw new Error('Request timed out. Please check your internet connection and try again.');
        }

        if (err.response?.status === 500) {
            throw new Error('Server error occurred. Please try again later.');
        }
        
        throw new Error(err.response?.data?.message || 'Add Branch failed');
    }
};

export const deleteBranch = async (branchId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${branchId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete Branch failed');
    }
};

export const updateBranch = async (branchId, branch) => {
    try {
        return await axiosApiClient.put(`${PATH}/${branchId}`, branch);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Branch failed');
    }
};

